import { I11PERCHADISCHA_State } from '@batical/types/src'

const I11PERCHADISCHA: I11PERCHADISCHA_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  tube_uuid: '5CA4979F-E809-486B-A81D-5C8C691E1BA2',
  in_debit: 100.0,
  viscosite_uuid: 'EEEECF26-EA40-4D13-AD09-0D99596F9F9C',
  perteCharg_uuid: '6D91E213-CFEA-4A37-A3FF-5A3D10E60966',
  in_longueur: 0.0,
  res_vitesse: 0.0,
  res_pdcParMetre: 0.0,
  res_pdcTotale: 0.0,
  mode: 'none',
  calcul_code: 'I11PERCHADISCHA'
}

export default I11PERCHADISCHA
